{
  "primary": {
    "50": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196,
          100,
          97.058824
        ],
        "alpha": 1,
        "hex": "#f0fbff"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          100,
          94.705882
        ],
        "alpha": 1,
        "hex": "#e4f6ff"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198.461538,
          95.121951,
          91.960784
        ],
        "alpha": 1,
        "hex": "#d7f2fe"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.2,
          92.592593,
          89.411765
        ],
        "alpha": 1,
        "hex": "#cbedfd"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198.181818,
          97.058824,
          86.666667
        ],
        "alpha": 1,
        "hex": "#bceafe"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.560976,
          100,
          83.921569
        ],
        "alpha": 1,
        "hex": "#ade7ff"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.142857,
          100,
          80.784314
        ],
        "alpha": 1,
        "hex": "#9de3ff"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196.173913,
          100,
          77.45098
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.636364,
          100,
          67.647059
        ],
        "alpha": 1,
        "hex": "#5ac9ff"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 500: base colour.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          202.396313,
          100,
          57.45098
        ],
        "alpha": 1,
        "hex": "#26aeff"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          206.352941,
          100,
          50
        ],
        "alpha": 1,
        "hex": "#008fff"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.339056,
          98.312236,
          53.529412
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.6,
          89.285714,
          43.921569
        ],
        "alpha": 1,
        "hex": "#0c5ad4"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.071429,
          94.382022,
          34.901961
        ],
        "alpha": 1,
        "hex": "#0548ad"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.716418,
          97.101449,
          27.058824
        ],
        "alpha": 1,
        "hex": "#023688"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.2,
          100,
          19.607843
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.74026,
          100,
          15.098039
        ],
        "alpha": 1,
        "hex": "#001a4d"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          222.545455,
          100,
          10.784314
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Primary brand colour — primary actions, links, and key accents. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          229.411765,
          100,
          6.666667
        ],
        "alpha": 1,
        "hex": "#000622"
      }
    }
  },
  "accent": {
    "50": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.428571,
          100,
          98.627451
        ],
        "alpha": 1,
        "hex": "#fff8f9"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          350.769231,
          100,
          97.45098
        ],
        "alpha": 1,
        "hex": "#fff2f4"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          350.526316,
          100,
          96.27451
        ],
        "alpha": 1,
        "hex": "#ffecef"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          350.4,
          100,
          95.098039
        ],
        "alpha": 1,
        "hex": "#ffe6ea"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.666667,
          100,
          92.941176
        ],
        "alpha": 1,
        "hex": "#ffdbe0"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.25,
          100,
          90.588235
        ],
        "alpha": 1,
        "hex": "#ffcfd6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.864407,
          100,
          88.431373
        ],
        "alpha": 1,
        "hex": "#ffc4cc"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          352.394366,
          100,
          86.078431
        ],
        "alpha": 1,
        "hex": "#ffb8c1"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          353.195876,
          87.387387,
          78.235294
        ],
        "alpha": 1,
        "hex": "#f897a2"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 500: base colour.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          354.098361,
          79.220779,
          69.803922
        ],
        "alpha": 1,
        "hex": "#ef7581"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          353.557047,
          73.399015,
          60.196078
        ],
        "alpha": 1,
        "hex": "#e44f5f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          348.556701,
          82.20339,
          46.27451
        ],
        "alpha": 1,
        "hex": "#d7153a"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.368421,
          85.929648,
          39.019608
        ],
        "alpha": 1,
        "hex": "#b90e32"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          345.810811,
          91.358025,
          31.764706
        ],
        "alpha": 1,
        "hex": "#9b072a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          344.878049,
          95.348837,
          25.294118
        ],
        "alpha": 1,
        "hex": "#7e0322"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          344.848485,
          100,
          19.411765
        ],
        "alpha": 1,
        "hex": "#630019"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.368421,
          100,
          14.901961
        ],
        "alpha": 1,
        "hex": "#4c0010"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.111111,
          100,
          10.588235
        ],
        "alpha": 1,
        "hex": "#360008"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Accent colour — secondary emphasis and supporting highlights. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          354.545455,
          100,
          6.470588
        ],
        "alpha": 1,
        "hex": "#210003"
      }
    }
  },
  "grey": {
    "50": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          98.039216
        ],
        "alpha": 1,
        "hex": "#fafafa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          96.078431
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          94.117647
        ],
        "alpha": 1,
        "hex": "#f0f0f0"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          92.156863
        ],
        "alpha": 1,
        "hex": "#ebebeb"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          5.660377,
          89.607843
        ],
        "alpha": 1,
        "hex": "#e3e5e6"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          195,
          6.060606,
          87.058824
        ],
        "alpha": 1,
        "hex": "#dcdfe0"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.142857,
          8.860759,
          84.509804
        ],
        "alpha": 1,
        "hex": "#d4d9db"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          9.89011,
          82.156863
        ],
        "alpha": 1,
        "hex": "#cdd3d6"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          6.25,
          68.627451
        ],
        "alpha": 1,
        "hex": "#aab0b4"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 500: base colour.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.385965,
          55.294118
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.587156,
          42.745098
        ],
        "alpha": 1,
        "hex": "#686f72"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          201.818182,
          7.006369,
          30.784314
        ],
        "alpha": 1,
        "hex": "#495054"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          7.352941,
          26.666667
        ],
        "alpha": 1,
        "hex": "#3f4549"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          8.62069,
          22.745098
        ],
        "alpha": 1,
        "hex": "#353b3f"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          10.416667,
          18.823529
        ],
        "alpha": 1,
        "hex": "#2b3135"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          206.666667,
          11.688312,
          15.098039
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          205.714286,
          12.727273,
          10.784314
        ],
        "alpha": 1,
        "hex": "#181c1f"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          15.151515,
          6.470588
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          210,
          28.571429,
          2.745098
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    }
  }
}
